import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { IDayBlockDTO } from '@app/infrastructure/models/day-block';

import { IConfirmDialogConfig } from '@models/dialog';

@Component({
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent implements OnInit {
  openFieldValue: string = '';
  disableSubmit: boolean = false;
  block: IDayBlockDTO;
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialog: IConfirmDialogConfig,
    private dialogRef: MatDialogRef<ConfirmDialogComponent>,
  ) {}

  ngOnInit(): void {
    if (this.dialog.showOpenField) {
      this.disableSubmit = this.dialog.openFieldVal.length === 0;
      this.openFieldValue = this.dialog.openFieldVal;
    }
    if (this.dialog.block) {
      this.block = this.dialog.block;
    }
  }

  public openFieldChange(event: any): void {
    this.openFieldValue = event;
    if (event.length) {
      this.disableSubmit = false;
    } else {
      this.disableSubmit = true;
    }
  }

  public submit(): void {
    const { id, showOpenField } = this.dialog;

    if (!showOpenField) {
      this.dialogRef.close(id);
    } else {
      const submitValue = this.openFieldValue;
      this.dialogRef.close({ id, submitValue });
    }
  }
}
